import { HTTPError } from "ky";
import { generateId } from "@evergis/api";
import { i18n } from "../../../i18n";

import { NotificationInfo } from "../../../ducks/notifications/notifications";

export const createNotificationInfo = (
  title: string,
  alias: string,
  layer: string,
  table: string,
): NotificationInfo => {
  return {
    id: generateId(),
    title,
    description: `${i18n.t("layer", { ns: "common" })} ${alias || layer}`,
    progress: true,
    duration: null,
    button: i18n.t("actions.cancel", { ns: "common" }),
    layer,
    table,
  };
};

export function createNotificationSuccess(
  title: string,
  alias: string,
  layer: string,
  table: string,
): NotificationInfo {
  return {
    id: generateId(),
    title,
    description: `${i18n.t("layer", { ns: "common" })} ${alias || layer}`,
    success: true,
    button: i18n.t("actions.cancel", { ns: "common" }),
    layer,
    table,
  };
}
export function createNotificationFail<E = HTTPError>(
  error?: E,
  { title, description }: Partial<NotificationInfo> = {},
): NotificationInfo {
  if (error instanceof HTTPError) {
    const status = error.response && error.response.status;

    if (status < 500 && status >= 400) {
      description = i18n.t("notifications.checkDataValidity", { ns: "tools" });
    }
  }

  return {
    id: generateId(),
    title: title || i18n.t("notifications.errorCreatingLayer", { ns: "tools" }),
    description: description || i18n.t("notifications.chooseAnotherSourceLayer", { ns: "tools" }),
  };
}

export function createNotificationCancel(title: string, alias: string): NotificationInfo {
  return {
    id: generateId(),
    title,
    description: `${i18n.t("layer", { ns: "common" })} ${alias}`,
  };
}
